<template>
  <div>
    <PageHeader title="Fan Leaderboard"></PageHeader>
      <v-container>
        <v-row>
          <v-col class="text-right">
            <router-link :to="{name: 'active-competitions'}">Competitions</router-link>
          </v-col>
        </v-row>
      </v-container>
      <v-card
        outlined
        v-for="fanPoint in fanPoints" :key="fanPoint.userId"
        class="mb-4"
      >
        <v-container>
          <v-row>
            <v-col cols="1">
              <v-icon color="fanhiveHoney" >mdi-account-circle</v-icon>
            </v-col>
            <v-col cols="4">
              {{fanPoint.userName}}
            </v-col>
            <v-col cols="7" class="text-right honey-colour">
              <v-icon color="fanhiveHoney">mdi-hexagon-slice-4</v-icon> {{fanPoint.honeyPointsBalance}}
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'fanleaderboard',
  components: {
    PageHeader
  },
  data: () => ({
    overlay: false,
    fanPoints: null
  }),
  methods: {
    getFanLeaderboard: function () {
      this.overlay = true;
      var scope = this;
      var slugParams = {
        slug: 'fanleaderboard',
        params: ''
      };
      this.$store.dispatch('getCustom', slugParams).then(response => {
        scope.fanPoints = response;
        scope.overlay = false
      }, error => {
          console.log(error);
      });
    }
  },
  created () {
    this.getFanLeaderboard();
  }
}
</script>